<template>
  <div ref="frame" @mousedown="mouseDownHandler" :style="{ left: x + 'px', top: y + 'px', width: modal.width + 'px' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    modal: { type: Object }
  },
  data() {
    return {
      x: -1,
      y: -1
    }
  },
  mounted() {
    this.initX = (document.documentElement.offsetWidth - this.modal.width) / 2;
    this.initY = 120;

    this.x = this.initX;
    this.y = this.initY;
  },
  methods: {
    mouseDownHandler(mouseEvent) {
      this.mouseDownX = mouseEvent.clientX;
      this.mouseDownY = mouseEvent.clientY;

      document.addEventListener("mousemove", this.mouseMoveHandler);
      document.addEventListener("mouseup", this.mouseUpHandler);
    },
    mouseMoveHandler(mouseEvent) {
      this.x = this.initX + mouseEvent.clientX - this.mouseDownX;
      this.y = this.initY + mouseEvent.clientY - this.mouseDownY;

      this.y = Math.min(this.y, document.documentElement.offsetHeight - this.$refs.frame.offsetHeight);
      this.y = Math.max(this.y, 0);
    },
    mouseUpHandler(mouseEvent) {
      this.initX = this.x;
      this.initY = this.y;

      document.removeEventListener("mousemove", this.mouseMoveHandler);
      document.removeEventListener("mouseup", this.mouseUpHandler);
    }
  }
}
</script>

<style scoped>
div {
  position: fixed;
  z-index: 6;
  border-radius: 10px;
  background-color: white;
}
</style>

